/**
 * AJAX Cart & Animations
 * Handles "Add to Cart" without page reload
 */

document.addEventListener('DOMContentLoaded', () => {
    initAjaxCart();
    createToastContainer();
});

function initAjaxCart() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');

    forms.forEach(form => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const submitBtn = form.querySelector('[type="submit"]');
            const originalText = submitBtn ? submitBtn.innerHTML : 'Add to Cart';

            // Visual feedback on button
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.innerHTML = '<span class="loading-spinner-btn"></span> Adding...';
                submitBtn.classList.add('loading');
            }

            try {
                const formData = new FormData(form);
                const config = {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/javascript'
                    },
                    body: formData
                };

                // 0. Inject Animation Elements if missing
                if (submitBtn && !submitBtn.querySelector('.cart-wrapper')) {
                    const cartWrap = document.createElement('div');
                    cartWrap.className = 'cart-wrapper';
                    cartWrap.innerHTML = `
            <svg class="cart-icon" viewBox="0 0 24 24">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
          `;
                    const dropBox = document.createElement('div');
                    dropBox.className = 'drop-box';

                    // Wrap existing text
                    if (!submitBtn.querySelector('.btn-text')) {
                        const textSpan = document.createElement('span');
                        textSpan.className = 'btn-text';
                        textSpan.innerHTML = submitBtn.innerHTML;
                        submitBtn.innerHTML = '';
                        submitBtn.appendChild(textSpan);
                    }

                    submitBtn.appendChild(cartWrap);
                    submitBtn.appendChild(dropBox);
                }

                // 1. Start Animation: Center, Drop, Squash
                if (submitBtn) {
                    submitBtn.classList.add('animating');
                }


                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', config);
                const cartItem = await response.json();

                // 2. Drive Away (After drop finishes approx 1.2s)
                setTimeout(() => {
                    if (submitBtn) {
                        submitBtn.classList.add('departing');
                    }
                }, 1200);

                // 3. Reset (Loop back)
                setTimeout(() => {
                    if (submitBtn) {
                        submitBtn.classList.remove('animating');
                        submitBtn.classList.remove('departing');
                        submitBtn.classList.add('returning');

                        // Force browser repaint for the teleport
                        setTimeout(() => {
                            requestAnimationFrame(() => {
                                submitBtn.classList.remove('returning');
                                submitBtn.classList.add('resetting');

                                // Cleanup classes
                                setTimeout(() => {
                                    submitBtn.classList.remove('resetting');
                                    submitBtn.disabled = false;
                                    submitBtn.classList.remove('loading'); // cleanup old loading class
                                    submitBtn.querySelector('.btn-text').innerHTML = originalText; // Restore original text
                                }, 500);
                            });
                        }, 50); // 50ms delay to ensure 'returning' state is painted
                    }

                    // Show toast/header update slightly delayed to match "exit"
                    updateCartCount();
                    animateCartIcon();
                    showToast('Added to cart!', `${cartItem.title} - ${formatMoney(cartItem.price)}`);

                }, 2000);

            } catch (error) {
                console.error('Error adding to cart:', error);
                showToast('Error', 'Failed to add item. Please try again.', true);
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.classList.remove('animating', 'loading');
                    submitBtn.innerHTML = originalText; // Restore original text on error
                }
            }
        });
    });
}

// Update the bubble count in the header
async function updateCartCount() {
    try {
        const res = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await res.json();

        document.querySelectorAll('.nav-cart__count').forEach(el => {
            // 1. Start Animation (Move Up & Out)
            el.classList.remove('spinner-up');
            void el.offsetWidth; // trigger reflow
            el.classList.add('spinner-up');

            // 2. Change Text halfway through (when invisible)
            setTimeout(() => {
                el.textContent = cart.item_count;
            }, 250); // Matches 50% of 0.5s animation

            // 3. Cleanup
            setTimeout(() => {
                el.classList.remove('spinner-up');
            }, 600);
        });
    } catch (e) {
        console.error(e);
    }
}

// Animate the cart icon in header
function animateCartIcon() {
    const cartIcon = document.querySelector('.nav-cart');
    if (cartIcon) {
        cartIcon.classList.remove('cart-animate');
        void cartIcon.offsetWidth; // trigger reflow
        cartIcon.classList.add('cart-animate');

        // Remove class after animation finishes to allow re-triggering
        setTimeout(() => {
            cartIcon.classList.remove('cart-animate');
        }, 1000);
    }
}

// Create the toast HTML structure
function createToastContainer() {
    if (document.querySelector('.ajax-toast')) return;

    const toast = document.createElement('div');
    toast.className = 'ajax-toast';
    toast.innerHTML = `
    <div class="ajax-toast__icon">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </div>
    <div class="ajax-toast__content">
      <span class="ajax-toast__title">Added to cart</span>
      <span class="ajax-toast__message">Product added successfully</span>
    </div>
    <a href="/cart" class="ajax-toast__link">View Cart</a>
  `;
    document.body.appendChild(toast);
    initToastSwipe(toast);
}

// Show the toast with dynamic message
function showToast(title, message, isError = false) {
    const toast = document.querySelector('.ajax-toast');
    if (!toast) return;

    toast.querySelector('.ajax-toast__title').textContent = title;
    toast.querySelector('.ajax-toast__message').textContent = message;

    if (isError) {
        toast.style.borderLeftColor = '#ff4444';
        toast.querySelector('.ajax-toast__icon').style.color = '#ff4444';
        toast.querySelector('.ajax-toast__icon').style.backgroundColor = '#ffecec';
        toast.querySelector('svg polyline').setAttribute('points', '18 6 6 18 6 6 18 18'); // X icon (pseudo) or just rely on text
    } else {
        toast.style.borderLeftColor = '#D4AF37';
        toast.querySelector('.ajax-toast__icon').style.color = '#D4AF37';
        toast.querySelector('.ajax-toast__icon').style.backgroundColor = '#fdf8e7';
    }

    toast.classList.add('active');

    // Auto-hide after 3 seconds
    const autoHideTimer = setTimeout(() => {
        toast.classList.remove('active');
    }, 3000);

    // Store timer to clear it if swiped
    toast.dataset.timerId = autoHideTimer;
}

// Initialize swipe behavior
function initToastSwipe(toast) {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    toast.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        toast.style.transition = 'none'; // distinct movement

        // Clear auto-hide timer when user touches
        if (toast.dataset.timerId) clearTimeout(parseInt(toast.dataset.timerId));
    }, { passive: true });

    toast.addEventListener('touchmove', (e) => {
        if (!isDragging) return;

        currentX = e.touches[0].clientX;
        const diffX = currentX - startX;

        // X-axis only movement
        toast.style.transform = `translateX(${diffX}px)`;

        // Optional: Fade out slightly as you drag further
        const opacity = 1 - Math.abs(diffX) / 300;
        toast.style.opacity = Math.max(opacity, 0.4);
    }, { passive: true });

    toast.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        toast.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';

        const diffX = currentX - startX;

        // Dismiss if dragged more than 100px Left or Right
        if (Math.abs(diffX) > 100) {
            // Animate off screen in the direction of swipe
            const dir = diffX > 0 ? 1 : -1;
            toast.style.transform = `translateX(${dir * 400}px)`;
            toast.style.opacity = '0';

            setTimeout(() => {
                toast.classList.remove('active');
                // Reset styling for next time
                setTimeout(() => {
                    toast.style.transform = '';
                    toast.style.opacity = '';
                }, 300);
            }, 300);
        } else {
            // Snap back to center
            toast.style.transform = '';
            toast.style.opacity = '';

            // Restart timer
            const newTimer = setTimeout(() => {
                toast.classList.remove('active');
            }, 3000);
            toast.dataset.timerId = newTimer;
        }
    });
}

// Helper to format money (simplified, can use Shopify's if available)
function formatMoney(cents) {
    return 'Rs. ' + (cents / 100).toFixed(2);
}
